<template>
    <div class="wrapper">
        <form method="post" class="form-signin" autocomplete="off" @submit.prevent="handleLogin">
            <h1>{{ $t('labels.register_device') }}</h1>

            <div class="alert alert-danger" v-if="!online" v-html="$t('messages.offline')"></div>

            <div class="form-group">
                <label for="email" class="sr-only">{{ $t('labels.email') }}</label>
                <input
                        type="email"
                        name="email"
                        id="email"
                        class="form-control"
                        :placeholder="$t('labels.email')"
                        v-model="identifier"
                        :disabled="!online"
                        required
                        autofocus>
            </div>

            <div class="form-group">
                <label for="password" class="sr-only">{{ $t('labels.password') }}</label>
                <input
                        type="password"
                        name="password"
                        id="password"
                        class="form-control"
                        :placeholder="$t('labels.password')"
                        v-model="password"
                        :disabled="!online"
                        required>
            </div>

            <div class="row">
                <div class="col-12 text-right">
                    <button class="btn btn-lg btn-primary btn--xl" type="submit" :disabled="!online || processing">
                        {{ $t('labels.login') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios';
    import * as config from '../config/config';
    import {loadAsyncLanguages, setLanguage} from "../translations/main";
    import {isOnline} from "../utils/online";

    export default {
        name: 'login',

        data() {
            return {
                identifier: '',
                password: '',
                processing: false,
            }
        },

        computed: {
            online () {
                return this.$store.state.online
            },

            currentDevice () {
                return this.$store.getters.currentDevice
            },

            currentLocation () {
                return this.$store.state.currentLocation;
            }
        },

        methods: {
            handleLogin() {
                this.$store.dispatch('clearErrors');

                this.processing = true;

                const credentials = {
                    email: this.identifier,
                    password: this.password
                };

                axios.post(config.api.baseUrl + '/authenticate', credentials)
                    .then(response => {
                        this.processing = false;
                        this.$store.dispatch('setToken', response.data.token);
                        this.$store.commit('setLanguage', response.data.language);
                        setLanguage(response.data.language);

                        if (
                            this.currentDevice !== null && this.currentDevice !== undefined
                            && this.currentLocation !== null && this.currentLocation !== undefined
                            && this.$route.name !== 'pin'
                        ) {
                            return this.$router.push({name: 'pin'});
                        }

                        this.$store.commit('setLocations', response.data.locations);
                        // this.$store.commit('setDevices', response.data.devices);
                        loadAsyncLanguages(response.data.translations, response.data.language);

                        const postData = {...credentials};
                        postData.register_workdays = this.regWorkdays;
                        postData.register_activities = this.regActivities;
                        postData.pre_register_activities = this.preReg;

                        this.$router.push({name: 'choose-location'});
                    })
                    .catch(error => {
                        this.processing = false;
                        this.password = '';
                        let data = error.response.data;

                        if (data.error !== null && data.error !== undefined) window.events.$emit('error', data.error);
                    });
            }
        },

        mounted () {
          if (process.env.NODE_ENV === 'development') console.log('Login:mounted::isOnline', this.$store.state.online)
            if (isOnline()) this.$store.commit('setOnline');
            else this.$store.commit('setOffline');

            if (this.currentDevice && !this.currentLocation && this.$route.name !== 'choose-location') {
                return this.$router.push({name: 'choose-location'});
            }

            if (this.currentDevice && this.currentLocation && this.$route.name !== 'pin') {
                return this.$router.push({name: 'pin'});
            }
        }
    }
</script>
